import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT  } from "constants/variables";
import Box from '@mui/material/Box'; 
import Container from '@mui/material/Container';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp"; 
import TableSortingContractStoreNimaAddresses from 'pages/contracts/editOrNewContract/SortingTablesContractsNimaAddress'; 
import PropTypes from 'prop-types'; 

const initialStateStoreNimaAddresses = [{
  "id":0,
  "roadtype_id":0,
  "roadtype_name":"",
  "street":"",
  "country_id":1,
  "country_name":"", 
  "province_id":30,
  "province_name":"",
  "postalcode_id":6911,
  "postalcode_code":"",
  "postalcode_name":"", 
  "community_id":6,
  "community_name":"", 
  "nima":"",
  "pygr_opt_tras":"",
  "grnp_opt_tras":"",
  "opt_id_opt_tras":0,
  "pygr_ori_tras":"",
  "grnp_ori_tras":"",
  "opt_id_ori_tras":0,
  "pygr_aut_tras":"",
  "grnp_aut_tras":"",
  "opt_id_aut_tras":0,
  "pygr_dest_tras":"",
  "grnp_dest_tras":"",
  "opt_id_dest_tras":0,
  "pygr_aut_dest":"",
  "grnp_aut_dest":"",
  "opt_id_aut_dest":0,
  "pygr_rel_trans":"",
  "grnp_rel_trans":"",
  "opt_id_rel_trans":0,
  "pygr_resp_prod":"",
  "grnp_resp_prod":"",
  "opt_id_resp_prod":0,
  
}];

const ContractSearchStoresNimaAddresses = ({ showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress,selectStores,setFormContract,titleTable,store_id}) => {
  const {t,i18n} = useTranslation(['listDataContracts']);
  const state = useSelector((state) => state);
  const {token} = state.loginUser
  const [dataStoreNimaAddresses, setDataStoreNimaAddresses] = useState(initialStateStoreNimaAddresses);
  const [numTotRegStoreNimaAddresses,setNumTotRegStoreNimaAddresses]= useState(0); 
 
  const dispatch = useDispatch(); 
   
  const keyPress = useCallback(
    (e) => {
     
      if (e.key === 'Escape' && showModalSearchStoresNimaAddress) {
        setDataStoreNimaAddresses(initialStateStoreNimaAddresses);
        setNumTotRegStoreNimaAddresses(0);
        setShowModalSearchStoresNimaAddress(false);
      }
    },
    [ setDataStoreNimaAddresses,
      setNumTotRegStoreNimaAddresses,
      showModalSearchStoresNimaAddress,
      setShowModalSearchStoresNimaAddress
    ]
  );

  const handleCloseDataEditStoreNimaAdresses = () => {
    setDataStoreNimaAddresses(initialStateStoreNimaAddresses);
    setNumTotRegStoreNimaAddresses(0);
    setShowModalSearchStoresNimaAddress(false);
	};

  const toggleDrawerSearchFormStoreNimaAddresses  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditStoreNimaAdresses();
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
       
  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegStoreNimaAdresses = async () => {
      try {
        const getData = await helpHttp().get11(ENDPOINT, `searchct/getinformationtablestoremimaaddress`, token,store_id);
        if (getData.err) {
          setDataStoreNimaAddresses(initialStateStoreNimaAddresses);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegStoreNimaAddresses(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
  
    const fetchDataStoreAdresses = async () => {
      try {
        const getData = await helpHttp().get11(ENDPOINT,`searchct/getnimaaddresssbystoreid`,token,store_id);
        if (getData.err || getData.message === "Load failed") {
          setDataStoreNimaAddresses(initialStateStoreNimaAddresses);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataStoreNimaAddresses(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    
    if (showModalSearchStoresNimaAddress){
      fetchnumTotRegStoreNimaAdresses(); 
      fetchDataStoreAdresses();
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,showModalSearchStoresNimaAddress,store_id]); 
  
  return(
    <>
      {showModalSearchStoresNimaAddress && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormStoreNimaAddresses(false)}
            onOpen={toggleDrawerSearchFormStoreNimaAddresses(true)}>
            <Container>
              <Box sx={{ bgcolor: '#ffffff',height:'1300px', width: '1100px'}}>
                <br/>
                <div className="formdi-pending-header2"> 
                  <h1 className="h1NewStyle mb-2"> {t('Text_CONTRACT_Stores_NimaAddress_Search')}</h1>
                   <div>
                    <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleCloseDataEditStoreNimaAdresses} >{t('Button_Back')}</button><> </>
                  </div>  
                </div>  
                <br/> 
               <div className="formdi-pending-card-flat">
                  <div className="formdi-pending-card-content">
                    <TableSortingContractStoreNimaAddresses
                      dataStoreNimaAddresses={dataStoreNimaAddresses}
                      numTotRegStoreNimaAddresses={numTotRegStoreNimaAddresses}
                      titleTable={titleTable}
                      selectStores={selectStores}
                      setFormContract={setFormContract}
                      handleCloseDataEditStoreNimaAdresses={handleCloseDataEditStoreNimaAdresses}
                    />
                  </div>             
                </div>
                {/* End Content Row */}                
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

ContractSearchStoresNimaAddresses.propTypes = {
  showModalSearchStoresNimaAddress : PropTypes.bool.isRequired,
  setShowModalSearchStoresNimaAddress : PropTypes.func.isRequired,
  selectStores : PropTypes.string.isRequired,
  setFormContract : PropTypes.func.isRequired,
  titleTable : PropTypes.string.isRequired 
};

export default ContractSearchStoresNimaAddresses;
